export default "__VITE_ASSET__C$D8vV0___"